var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [
      _c("v-data-table", {
        staticClass: "specimen-selection-table",
        attrs: {
          search: _vm.search,
          headers: _vm.headers,
          items: _vm.specimena,
          "item-key": _vm.ID_KEY,
          "select-all": "",
          pagination: _vm.pagination,
        },
        on: {
          "update:pagination": function ($event) {
            _vm.pagination = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "headers",
            fn: function (props) {
              return [
                _c(
                  "tr",
                  [
                    _c(
                      "th",
                      [
                        _c("v-checkbox", {
                          attrs: {
                            color: "primary",
                            "input-value": props.all,
                            indeterminate: props.indeterminate,
                            primary: "",
                            "hide-details": "",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.toggleAll.apply(null, arguments)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(props.headers, function (header) {
                      return _c(
                        "th",
                        {
                          key: header.text,
                          class: [
                            "column sortable",
                            _vm.pagination.descending ? "desc" : "asc",
                            header.value === _vm.pagination.sortBy
                              ? "active"
                              : "",
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.changeSort(header.value)
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("arrow_upward"),
                          ]),
                          _vm._v(
                            "\n          " + _vm._s(header.text) + "\n        "
                          ),
                        ],
                        1
                      )
                    }),
                  ],
                  2
                ),
              ]
            },
          },
          {
            key: "items",
            fn: function (props) {
              return [
                _c(
                  "tr",
                  {
                    staticClass: "clickable",
                    attrs: { active: props.selected },
                    on: {
                      click: function ($event) {
                        props.selected = !props.selected
                      },
                    },
                  },
                  [
                    _c(
                      "td",
                      [
                        _c("v-checkbox", {
                          attrs: {
                            color: "info",
                            "hide-details": "",
                            "input-value": props.selected,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(props.item.SpeciesCode))]),
                  ]
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }